import { useFormContext, useWatch, useController } from "react-hook-form";
import { DeleteForever as DeleteForeverIcon } from "@mui/icons-material";
import { Link } from "react-router-dom";
import { useAddressAutofill } from "../../hooks/useAddressAutofill";
import AddressAutocompleteInput from "../../components/AddressAutocompleteInput";

function AddressTableRows({ isAdding, deleteTableRow }) {
  const { register, formState: { errors }, setValue, control } = useFormContext();
  const selectedState = useWatch({ control, name: 'state' });
  const { field: suburbField } = useController({ name: 'suburb', control });
  const { field: postcodeField } = useController({ name: 'postcode', control });

  const { suburbs, postcodes, handleSuburbValueChange, handlePostcodeValueChange } = useAddressAutofill({
    state: selectedState,
    setState: (value) => setValue('state', value),
    setSuburb: (value) => setValue('suburb', value),
    setPostcode: (value) => setValue('postcode', value),
  });

  return (
    isAdding && (
      <tr>
        <td className="border">
          <input placeholder="Name or Company" type="text" {...register('company')} className={`form-control ${errors.company ? 'is-invalid' : ''}`}/>
        </td>
        <td className="border">
          <input placeholder="Number & Street" type="text" {...register('street1')} className={`form-control ${errors.street1 ? 'is-invalid' : ''}`}/>
        </td>
        <td className="border">
          <AddressAutocompleteInput
            name={suburbField.name}
            value={suburbField.value}
            onChange={suburbField.onChange}
            onBlur={suburbField.onBlur}
            inputRef={suburbField.ref}
            options={suburbs}
            onValueChange={handleSuburbValueChange}
            placeholder="Suburb"
            className={`form-control ${errors.suburb ? 'is-invalid' : ''}`}
          />
        </td>
        <td className="border">
          <select
            {...register('state')}
            className={`form-select ${errors.state ? 'is-invalid' : ''}`}
            defaultValue={""}
          >
            <option value="" hidden>State</option>
            <option value="ACT">ACT</option>
            <option value="NSW">NSW</option>
            <option value="NT">NT</option>
            <option value="QLD">QLD</option>
            <option value="SA">SA</option>
            <option value="TAS">TAS</option>
            <option value="VIC">VIC</option>
            <option value="WA">WA</option>
          </select>
        </td>
        <td className="border">
          <AddressAutocompleteInput
            name={postcodeField.name}
            value={postcodeField.value}
            onChange={postcodeField.onChange}
            onBlur={postcodeField.onBlur}
            inputRef={postcodeField.ref}
            options={postcodes}
            onValueChange={handlePostcodeValueChange}
            placeholder="Postcode"
            className={`form-control ${errors.postcode ? 'is-invalid' : ''}`}
          />
        </td>
        <td className="border"></td>
        <td className="border"></td>
        <td className="border">
          <Link style={{cursor: 'pointer'}} onClick={() => deleteTableRow()}><DeleteForeverIcon /></Link>
        </td>
      </tr>
    )
  );
}

export default AddressTableRows;
